var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgUltimate = function SvgUltimate(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 47.25 51.73"
  }, props), _defs || (_defs = React.createElement("defs", null, React.createElement("linearGradient", {
    id: "ultimate_svg__linear-gradient",
    x1: 20.53,
    y1: -2.97,
    x2: 19.9,
    y2: 20.97,
    gradientTransform: "rotate(30.12 -15.701 41.63)",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#33bcc7"
  })), React.createElement("linearGradient", {
    id: "ultimate_svg__linear-gradient-2",
    x1: 22.35,
    y1: -2.14,
    x2: 22.49,
    y2: 15.6,
    gradientTransform: "rotate(30.12 -15.701 41.63)",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0,
    stopColor: "#e1eff8"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#33bcc7"
  })), React.createElement("linearGradient", {
    id: "ultimate_svg__linear-gradient-3",
    x1: 546.97,
    y1: 5.01,
    x2: 546.25,
    y2: 32.18,
    gradientTransform: "rotate(-60.6 286.772 469.557)",
    xlinkHref: "#ultimate_svg__linear-gradient"
  }), React.createElement("linearGradient", {
    id: "ultimate_svg__linear-gradient-4",
    x1: 546.61,
    y1: 6.08,
    x2: 546.74,
    y2: 22.82,
    gradientTransform: "rotate(-60.6 286.772 469.557)",
    xlinkHref: "#ultimate_svg__linear-gradient-2"
  }), React.createElement("linearGradient", {
    id: "ultimate_svg__linear-gradient-5",
    x1: 16.57,
    y1: 21.28,
    x2: 16.11,
    y2: 38.89,
    gradientTransform: "rotate(96.21 12.644 30.437)",
    xlinkHref: "#ultimate_svg__linear-gradient"
  }), React.createElement("linearGradient", {
    id: "ultimate_svg__linear-gradient-6",
    x1: 0.73,
    y1: -8.51,
    x2: 0.82,
    y2: 1.77,
    gradientTransform: "rotate(92.54 -10.028 22.485)",
    xlinkHref: "#ultimate_svg__linear-gradient-2"
  }), React.createElement("radialGradient", {
    id: "ultimate_svg__radial-gradient",
    cx: 75.87,
    cy: 72.43,
    r: 149.17,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.32,
    stopColor: "#00283d"
  }), React.createElement("stop", {
    offset: 0.43,
    stopColor: "#00565e"
  }), React.createElement("stop", {
    offset: 0.58,
    stopColor: "#009189"
  }), React.createElement("stop", {
    offset: 0.71,
    stopColor: "#00c1ab"
  }), React.createElement("stop", {
    offset: 0.83,
    stopColor: "#00e3c4"
  }), React.createElement("stop", {
    offset: 0.93,
    stopColor: "#00f7d3"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#00ffd8"
  })), React.createElement("radialGradient", {
    id: "ultimate_svg__radial-gradient-2",
    cx: 14.56,
    cy: 8.76,
    r: 38.13,
    gradientTransform: "rotate(92.54 -10.028 22.485)",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.32,
    stopColor: "#30d5c9"
  }), React.createElement("stop", {
    offset: 0.77,
    stopColor: "#3993df"
  })), React.createElement("style", null, ".ultimate_svg__cls-5{opacity:.95}"))), _g || (_g = React.createElement("g", {
    id: "ultimate_svg__Layer_2",
    "data-name": "Layer 2"
  }, React.createElement("g", {
    id: "ultimate_svg__Logos"
  }, React.createElement("path", {
    d: "M23.63 50.73a8.2 8.2 0 01-4.05-1.07l-7.18-4.14-7.35-4.25a8.14 8.14 0 01-4-7V17.48a8.09 8.09 0 014.05-7l14.48-8.39a8.07 8.07 0 018.1 0l14.52 8.38a8.13 8.13 0 014 7v16.78a8.18 8.18 0 01-4 7l-14.52 8.4a8.16 8.16 0 01-4.05 1.08z",
    fill: "#fff"
  }), React.createElement("path", {
    d: "M23.63 50.73a8.2 8.2 0 01-4.05-1.07l-7.18-4.14-7.35-4.25a8.14 8.14 0 01-4-7V17.48a8.09 8.09 0 014.05-7l14.48-8.39a8.07 8.07 0 018.1 0l14.52 8.38a8.13 8.13 0 014 7v16.78a8.18 8.18 0 01-4 7l-14.52 8.4a8.16 8.16 0 01-4.05 1.08z",
    fill: "url(#ultimate_svg__radial-gradient)"
  }), React.createElement("path", {
    d: "M23.63 2a7.07 7.07 0 013.55 1l14.52 8.34a7.09 7.09 0 013.55 6.14v16.77a7.15 7.15 0 01-3.55 6.16l-14.52 8.38a7.17 7.17 0 01-7.1 0l-7.18-4.14L6.64 41l-1.09-.62A7.13 7.13 0 012 34.25V17.48a7.06 7.06 0 013.55-6.14L20.08 3a7 7 0 013.55-1m0-2a9.15 9.15 0 00-4.56 1.23L4.55 9.61A9.09 9.09 0 000 17.48v16.77a9.16 9.16 0 004.55 7.89l1.09.62 6.26 3.62 7.18 4.14a9.14 9.14 0 009.09 0l14.53-8.38a9.19 9.19 0 004.55-7.89V17.48a9.11 9.11 0 00-4.55-7.87L28.18 1.23A9.11 9.11 0 0023.63 0z",
    fill: "#b9e8ee"
  }), React.createElement("path", {
    d: "M33.59 26.3c1.51.28 7.15-2.2 7.15-2.2s-4.37 4.33-4.67 5.84 2.21 7.15 2.21 7.15-4.48-4.42-5.84-4.67-7.16 2.2-7.16 2.2 4.41-4.49 4.69-5.89-2.21-7.11-2.21-7.11 4.32 4.38 5.83 4.68z",
    fill: "url(#ultimate_svg__linear-gradient)"
  }), React.createElement("path", {
    d: "M40.74 24.1s-4.37 4.33-4.67 5.84 2.21 7.15 2.21 7.15-4.48-4.42-5.84-4.67-7.16 2.2-7.16 2.2z",
    fill: "url(#ultimate_svg__linear-gradient-2)"
  }), React.createElement("path", {
    d: "M17.92 24c-1.81-.59-9 1.58-9 1.58s6-4.58 6.55-6.37-1.59-9-1.59-9 4.77 6 6.37 6.54 9-1.58 9-1.58-6 4.78-6.57 6.43 1.61 8.94 1.61 8.94-4.59-5.96-6.37-6.54z",
    fill: "url(#ultimate_svg__linear-gradient-3)"
  }), React.createElement("path", {
    d: "M8.91 25.59s6-4.58 6.55-6.37-1.59-9-1.59-9 4.77 6 6.37 6.54 9-1.58 9-1.58z",
    fill: "url(#ultimate_svg__linear-gradient-4)"
  }), React.createElement("path", {
    d: "M13.92 32.08c1.15-.22 4.44-3.49 4.44-3.49s-1.9 4.22-1.69 5.37 3.48 4.44 3.48 4.44-4.34-1.9-5.36-1.71-4.44 3.49-4.44 3.49 1.88-4.35 1.69-5.41-3.47-4.4-3.47-4.4 4.23 1.91 5.35 1.71z",
    fill: "url(#ultimate_svg__radial-gradient-2)"
  }), React.createElement("path", {
    d: "M13.92 32.08c1.15-.22 4.44-3.49 4.44-3.49s-1.9 4.22-1.69 5.37 3.48 4.44 3.48 4.44-4.34-1.9-5.36-1.71-4.44 3.49-4.44 3.49 1.88-4.35 1.69-5.41-3.47-4.4-3.47-4.4 4.23 1.91 5.35 1.71z",
    fill: "url(#ultimate_svg__linear-gradient-5)"
  }), React.createElement("path", {
    d: "M18.36 28.59s-1.9 4.22-1.69 5.37 3.48 4.44 3.48 4.44-4.34-1.9-5.36-1.71-4.44 3.49-4.44 3.49z",
    fill: "url(#ultimate_svg__linear-gradient-6)"
  })))));
};
export default __webpack_public_path__ + "2217392b1121e4a1f4645b2bf84e8acf.svg";
export { SvgUltimate as ReactComponent };